import React from 'react';
import { View, Image } from '@react-pdf/renderer';

const styles = {
  backgroundImage: {
    width: '98%',
    height: '99%%',
    objectFit: 'fill' as const,
    position: 'absolute' as const,
    top: '3.5%',
    left: '2.5%',
    minHeight: '90%',
    maxHeight: '99%',
    transform: 'scale(1.1)',
    transformOrigin: 'center center',
    zIndex: 3,
    opacity: 0.7
  }
};

const PageBackground: React.FC = () => (
  <View style={styles.backgroundImage}>
    <Image src="/background_e-invoice.png" />
  </View>
);

export default PageBackground;
